import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {Roles} from "../shared/models/roles";
import {AuthorizationGuardService} from "@westjetairlines/wjesd-oauth2-library";
import {ManageIataComponent} from "./manage-iata.component";

const manageIataRoutes: Routes = [
  {
    path: 'manage-iata',
    component: ManageIataComponent,
    canActivate: [AuthorizationGuardService],
    data: { roles: [Roles.IataAdmin] }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(manageIataRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ManageIataRoutingModule { }
/**
 * Created by tking on 19/07/2018.
 */



// WEBPACK FOOTER //
// ./src/app/manage-iata/manage-iata-routing.module.ts